"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUsersEndpoint = exports.getUsersEndpoint = void 0;
var routes_1 = require("~shared/utils/routes");
exports.getUsersEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/user/',
    method: 'get'
});
exports.updateUsersEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/user/',
    method: 'put'
});
//# sourceMappingURL=users.js.map